<template>
    <div class="app_container">
        <el-card class="search-form-card" style="padding-bottom: 10px;">
            <el-form :inline="true" :model="form" class="search-form" label-width="80px">
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="编号:">
                            <el-input v-model="form.serial_number" placeholder="请输入" @keyup.enter.native="loadData" class="common-input"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="项目名称:">
                            <el-select v-model="form.project_name" placeholder="请选择"  filterable>
                                <el-option v-for="item in projectName" :key="item.id" :label="item.cname"
                                           :value="item.ename"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="申请人:">
                            <el-input type="text" placeholder="请选择" disabled v-model="applyName" class="people-input"></el-input>
                            <router-link :to="{ path:'/requesterList',query: { callback:getCurrentHandler } }">
                                <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                            </router-link>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="状态:">
                            <el-select v-model="form.status" placeholder="请选择"  filterable>
                                <el-option v-for="item in resourceStatus" :key="item.id" :label="item.cname"
                                           :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="所在位置:">
                            <el-select v-model="form.location" placeholder="请选择"  filterable>
                                <el-option v-for="item in locationList" :key="item.id" :label="item.cname"
                                           :value="item.ename"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="使用人:">
                            <el-input type="text" placeholder="请选择" disabled v-model="userName" class="people-input"></el-input>
                            <router-link :to="{ path:'/requesterList',query: { callback:getUserName } }">
                                <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                            </router-link>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="资源类型:">
                            <el-select v-model="form.resource_type" placeholder="请选择"  filterable>
                                <el-option v-for="item in resourceType" :key="item.id" :label="item.alias"
                                           :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="10">
                        <el-form-item label="创建时间:">
                            <el-date-picker
                                v-model="createTime"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-button type="primary" @click="loadData">查询</el-button>
                        <el-button type="primary" @click="reset">重置</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <el-card>
            <div slot="header">
                <router-link  :to="{ path:'/resourceApplyAdd' ,query: { callback:request }}">
                    <el-button type="primary" v-w-role="'ITSM-0304-1'">创建</el-button>
                </router-link>
            </div>
            <el-table :data="tableData" v-loading="!loading" >
                <el-table-column label="序号" width="50" align="center">
                    <template slot-scope="scope">
                        <span v-if="form.page_size===10"> {{form.page_index>1 ? scope.$index+1+(form.page_index-1)*10 : scope.$index+1}}</span>
                        <span v-if="form.page_size===20"> {{form.page_index>1 ? scope.$index+1+(form.page_index-1)*20 : scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="编号" prop="serial_number"></el-table-column>
                <el-table-column label="项目名称" prop="project_name"  >
                    <template slot-scope="scope">
                        {{ scope.row.project_name | getCname( projectName)}}
                    </template>
                </el-table-column>
                <el-table-column label="资源类型" prop="resource_type"></el-table-column>
                <el-table-column label="所在位置" prop="location">
                    <template slot-scope="scope">{{ scope.row.location | getCname( locationList)}}</template>
                </el-table-column>
                <el-table-column label="状态" prop="status">
                    <template slot-scope="scope">
                        {{  getNameById(scope.row.status, resourceStatus)}}
                    </template>
                </el-table-column>
                <el-table-column label="申请人" prop="applicant">

                </el-table-column>
                <el-table-column label="使用人" prop="user"></el-table-column>
                <el-table-column label="开始时间" prop="create_time"></el-table-column>
                <el-table-column label="结束时间" prop="close_time" width="140">
                </el-table-column>
                <el-table-column label="操作" fixed="right" min-width="120">
                    <template slot-scope="scope">
                        <router-link :to="{ path: '/resourceApplyDetail', query: { serialNumber:scope.row.serial_number }}">
                            <el-button type="text">详情</el-button>
                        </router-link>
                        <el-button v-if="scope.row.status=='900'" class="table-del-btn" type="text" @click="deleteEvent(scope.row)" v-w-role="'ITSM-0304-2'">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.page_index"
                           :page-sizes="[10,20]"
                           :page-size="form.page_size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>

    import services from "./resourceApply.service"
    export default {
        data() {
            return {
                form:{
                    location:"",
                    project_name:"",
                    status:"",
                    resource_type:"",
                    applicant:"",
                    start_time:"",
                    stop_time:"",
                    serial_number:"",
                    user:"",
                    page_size:10,
                    page_index:1,
                    filter_condition:'mine'
                },
                total:null,
                tableData:[],
                createTime:[],
                applyName:'',//申请人
                userName:'', //使用人
                loading:true,
            }
        },
        created() {
            this.$store.dispatch('getResourceType')
            this.request();
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            //项目名称
            projectName(){
                return this.dictionary.project_name
            },
            // 位置
            locationList(){
                return this.dictionary.location
            },
            //状态
            resourceStatus(){
                return this.dictionary.resource_application_status
            },
            //资源类型
            resourceType(){
                return this.$store.state.resourceTypeList
            }
        },
        methods: {
            loadData(){
                this.loading = true;
                this.form={
                    ...this.form,
                    start_time: this.createTime[0]?this.createTime[0]:'',
                    stop_time:this.createTime[1]?this.createTime[1]:'',
                }
                // console.log(this.form)
                this.form.page_index = 1;
                this.request();
            },
            request(){
                // // 获取列表数据

                services.getResourceApplyList(this.form).then(res => {
                    // console.log(res,'这是changeManage里的request请求后，打印res');
                    this.tableData = res.list;

                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = true;
                })
            },
            reset(){
                this.form={
                    location:"",
                    project_name:"",
                    state:"",
                    resource_type:"",
                    applicant:"",
                    start_time:"",
                    stop_time:"",
                    serial_number:"",
                    user:"",
                    page_size:10,
                    page_index:1,
                    filter_condition:'mine'
                }
                this.createTime=[]
                this.applyName=''
                this.userName=''
            },
            //选择的申请人
            getCurrentHandler(obj){
                // console.log(obj,'选择指派人[0]');
                this.applyName=obj.name
                this.form={
                    ...this.form,
                    applicant:obj.internalUserid
                }
                // console.log(this.form.designator);
            },
            //选择的使用人
            getUserName(obj){
                this.userName=obj.name
                this.form={
                    ...this.form,
                    user:obj.internalUserid
                }
            },
            deleteEvent(row){
                this.openMessage('您确定要删除吗？', '确定', () => {
                    services.deleteResourceApply({ serial_number:row.serial_number }).then(res => {
                        this.$message.success("删除成功");
                        this.request();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.page_size = val;
                if(this.form.page_index > pages ){
                    this.form.page_index  = 1;
                };
                this.request()
            },
            handleCurrentChange(val){
                this.form.page_index = val;
                this.request();
            }
        }
    }
</script>

<style scoped>

</style>
